import { PackUsageCard } from './PackUsageCard';
import { PlanDetailsType } from 'src/types/types';

type TicketPacksSectionProps = {
  planDetails: PlanDetailsType | null;
};

export const TicketPacksSection = ({ planDetails }: TicketPacksSectionProps) => {
  const activePacks =
    planDetails?.ticket_packs
      ?.filter((p) => p.status === 'active')
      .sort((a, b) => new Date(a.expires_at).getTime() - new Date(b.expires_at).getTime()) || [];

  if (activePacks.length === 0) {
    return (
      <div className="mt-3 pt-3 text-center text-600" style={{ borderTop: '1px solid #e0e0e0' }}>
        No active ticket packs
      </div>
    );
  }

  return (
    <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e0e0e0' }}>
      <p className="text-sm text-600 mb-3">Used automatically after subscription</p>

      {activePacks.map((pack, index) => (
        <PackUsageCard key={pack.pack_id} pack={pack} isNextToUse={index === 0} />
      ))}
    </div>
  );
};
